import React, { useState } from 'react';
import { fileExport, paymentRefund } from '../../../api-services';
// import RefundModal from './modal/RefundModal';
import Dropdown from 'react-bootstrap/Dropdown';
import {
  openModalGlobal,
  openUserDetailsModal,
} from '../../../redux/features/modalSlice';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollar, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../../components/TableManager';
import { useMutation } from 'react-query';
import swal from 'sweetalert';

const table = createTable();
const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];
const currencyOptions = [
  { label: 'EURO', value: 'EURO' },
  { label: 'XOF', value: 'XOF' },
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'NGN', value: 'NGN' },
];
const statusOptions = [
  { label: 'Active', value: 'A' },
  { label: 'Deactive', value: 'D' },
];

const initialValues = {
  filter: [
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      invoice_number: '',
      a_filter_type: '',
      placeholder: 'Enter Invoice Number...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'Invoice Number',
    },
    {
      currency: '',
      a_filter_type: '',
      placeholder: 'Select Currency...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: currencyOptions,
      label: 'Currency',
    },
    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Select Refund Date...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Refund Date',
    },
  ],
};

const Refund = () => {
  const dispatch = useDispatch();
  const [openModalRefund, setOpenModalRefund] = useState(false);
  const [openModalRefundData, setOpenModalRefundData] = useState({});
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const { isLoading: isLoadingExporting, mutateAsync: mutateAsyncExport } =
    useMutation(
      'fileExport',
      (payload) => fileExport(payload, 'payment/refund'),
      {
        onSuccess: (data) => {
          window.open(data?.data?.data);
        },
        onError: (error) => {
          swal({
            title: error?.response?.data?.message,
            type: 'danger',
            icon: 'error',
          });
        },
      },
    );

  const handleRefundModal = (data) => {
    return false;
    // setOpenModalRefund(true);
    // setOpenModalRefundData(data);
  };

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const handleFileExport = async (payload) => {
    await mutateAsyncExport(payload);
  };

  const columns = [
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'MSISDN',
      shouldPointer: true,
      cell: (props) => (
        <span
          className="hover-name"
          onClick={() =>
            handleOpenUserDetails(
              props.getValue(),
              props?.row?.original?.customer,
            )
          }
        >
          {props.getValue()}
        </span>
      ),
    }),

    table.createDataColumn('invoice_number', {
      id: 'invoice_number',
      header: 'Invoice Number',
    }),
    table.createDataColumn('refund_date', {
      id: 'refund_date',
      header: 'Refund Date',
      isSortable: true,
    }),

    table.createDataColumn('refund_amount', {
      id: 'refund_amount',
      header: 'Refund amount',
      textAlign: 'left',
      isSortable: true,
    }),
    table.createDataColumn('currency', {
      id: 'currency',
      header: 'Currency',
      textAlign: 'left',
    }),

    table.createDataColumn('status', {
      id: 'status',
      header: 'Status',
      textAlign: 'left',
    }),
    // table.createDisplayColumn({
    //   id: 'action',
    //   header: 'Action',
    //   cell: (props) => (
    //     <span>
    //       <Dropdown className="dropdown_dot mx-auto">
    //         <Dropdown.Toggle
    //           id="dropdown-basic"
    //           className="btn-light-blue btn-action "
    //         >
    //           <FontAwesomeIcon icon={faEllipsisV} />
    //         </Dropdown.Toggle>

    //         <Dropdown.Menu>
    //           <Dropdown.Item
    //             href={void 0}
    //             onClick={() => handleRefundModal(props.row.original)}
    //           >
    //             <FontAwesomeIcon icon={faDollar} />

    //             {props.row.original.refund_date !== '1970-01-01'
    //               ? 'Refunded'
    //               : 'Refund'}
    //           </Dropdown.Item>
    //         </Dropdown.Menu>
    //       </Dropdown>
    //     </span>
    //   ),
    // }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="paymentRefund"
        fetcherFn={paymentRefund}
        title="Refund Report"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
        shouldExport={true}
        exportCtaFn={handleFileExport}
        isExporting={isLoadingExporting}
      />

      {/* <RefundModal
        openModalRefund={openModalRefund}
        setOpenModalRefund={setOpenModalRefund}
        openModalRefundData={openModalRefundData}
        setOpenModalRefundData={setOpenModalRefundData}
      /> */}
    </>
  );
};

export default Refund;
